const initState = {
    headerSlides: []
};

export default function programPageReducer(state = initState, action) {
    switch (action.type) {
        case "setStaticData":
            return setStaticData(state, action);
        default:
            return state;
    }
}

function setStaticData(state, { payload }) {
    // console.log(payload);
    return {
        ...state,
        headerSlides: payload["header_slider"]["slides"].map(s => ({
            id: s["uid"],
            title: s["title"],
            subtitle: s["subtitle"],
            image: s["image"],
            image2: s["image_2"],
            buttonText: s["button_text"],
            buttonColor: s["button_color"],
            buttonBgColor: s["button_background"],
            showButton: s["show_button"],
            programId: s["program_uid"]
        }))
    };
}
